function formatCurrency(value?: number | null, removeDecimals = false) {
  if (value === undefined || value === null || isNaN(value)) {
    value = 0;
  }

  if (removeDecimals) {
    return value.toLocaleString("en-ZA", {
      style: "currency",
      currency: "ZAR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  // to ZAR
  return value.toLocaleString("en-ZA", {
    style: "currency",
    currency: "ZAR",
  });
}

export { formatCurrency };
